module.exports = __webpack_public_path__ + "img/abstract_3.d480929c.png";